import { createContext, useContext } from 'react';
import type { DatePickerContextValue } from './DatePickerModal.types';

export const DatePickerContext = createContext<DatePickerContextValue | null>(
  null
);

export function useDatePickerContext(): DatePickerContextValue {
  const ctx = useContext(DatePickerContext);
  if (!ctx) {
    throw new Error(
      'DatePicker compound components must be rendered inside <DatePickerModal.Root>'
    );
  }
  return ctx;
}
